export default [
    {
        key: "ostrov__polka_pribornaya",
        allArray: "allPolkaPribornaya",
        activeArray: "activePolkaPribornaya",
        position: "top",
        extra: (el) => {
            const polkaPribornaya = servObj.allPolkaPribornaya.filter(
                (item) => item.name.includes("polka_pribornaya__dsp") && !item.name.includes("ostrov"),
            )[0];
            const osveshchenieArr = polkaPribornaya.children.filter((item) =>
                item.name.includes("osveshchenie_pod_pribornuyu_polku"),
            );
            const replaceChildNames = (obj, suffix) => {
                obj.children.forEach((child) => {
                    child.name = child.name.replace(
                        /__(\d+)(?:_)?/,
                        (match, num) => `__${num}__${suffix}${match.endsWith("_") ? "_" : ""}`,
                    );
                });
            };
            osveshchenieArr.forEach((osveshchenie) => {
                const newOsveshchenie = osveshchenie.clone();
                newOsveshchenie.userData.isChildren = true;
                newOsveshchenie.userData.placement = "front";
                newOsveshchenie.name += "__front";
                replaceChildNames(newOsveshchenie, "front");
                el.add(newOsveshchenie);
                const newOsveshchenieBack = osveshchenie.clone();
                // Отзеркаливаем
                newOsveshchenieBack.scale.z *= -1;
                newOsveshchenieBack.userData.isChildren = true;
                newOsveshchenieBack.userData.placement = "back";
                newOsveshchenieBack.name += "__back";
                replaceChildNames(newOsveshchenieBack, "back");
                el.add(newOsveshchenieBack);
            });
        },
    },
    {
        key: "ostrov__osveshchenie_verkhnee",
        allArray: "allOsveshchenieVerkhnee",
        activeArray: "activeOsveshchenieVerkhnee",
        position: "top",
    },
    {
        key: "ostrov__perfopanel",
        allArray: "allPerfopanel",
        activeArray: "activePerfopanel",
        position: "top",
        extra: (el) => {
            el.userData.bsize = servObj.building.getBoundaryGeometry(el);
        },
    },
    {
        key: "ostrov__panel_elektromontazhnaya",
        allArray: "allPanelElektromontazhnaya",
        activeArray: "activePanelElektromontazhnaya",
        position: "top",
        extra: (el) => {
            el.userData.bsize = servObj.building.getBoundaryGeometry(el);
        },
    },
    {
        key: "ostrov__planka_dlya_lotkov",
        allArray: "allPlankaDlyaLotkov",
        activeArray: "activePlankaDlyaLotkov",
        position: "top",
    },
    {
        key: "ostrov__polka_nizhnyaya",
        allArray: "allShelfDownSide",
        activeArray: "activeShelfDownSide",
        position: "bottom",
    },
    {
        key: "ostrov__ogranichitel",
        allArray: "allTableStops",
        activeArray: "activeTableStops",
        position: "bottom",
    },
    {
        key: "ostrov__instrumentalnaya_planka",
        position: "top",
        extra: (el) => {
            const width = el.name.split("__").at(-1);
            servObj.allOsveshchenieVerkhnee.forEach((item) => {
                if (item.name.includes(width) && item.name.includes("ostrov")) {
                    const newObject = el.clone();
                    item.attach(newObject);
                }
            });
        },
    },
];
